export const RESIZER_POSITIONS = {
  NW: 'NW',
  NE: 'NE',
  SE: 'SE',
  SW: 'SW',
};
